module.exports = __webpack_public_path__ + "img/symbol_10.275a133d.png";